import { CalculusUtils } from "../utils/calculus";
import { PeriodDateUtils, getDatesByMacro } from "../utils/dates";

//Groups the elements of an array by a key
const groupBy = (initialArray, groupByKey) => {
    return initialArray.reduce(function(rv, x) {
      (rv[x[groupByKey]] = rv[x[groupByKey]] || []).push(x);
      return rv;
    }, {});
};

//Returns an a sorted array with the values from an object
const sortObjByValues = (obj) => {
    const sortable = [];
    for (var entity in obj) {
        sortable.push({[entity]: obj[entity]});
    }
    return sortable.sort((a, b) => Object.values(b)[0] - Object.values(a)[0]);
}

//Returns an array with the values  from am object
const getValuesFromKeys = (arr) =>{
    const values = [];
    for (let i=0; i<arr.length; i++){
        values.push(Object.keys(arr[i])[0])
    }
    return values.length === 10 ? values.slice(0, -1) : values;
}

//Returns an array with the elements include in first array and not present in the second one
const getDiffBetweenArrays= (a, b) => a.filter(element => !b.includes(element));

//Returns an array with the keys of the object with the most keys from an input array
const getUniquePropertyValues = (inputData, property) => {
    const uniqueValuesSet = new Set();
    inputData.forEach(innerArray => {
        innerArray.forEach(obj => {
            if (obj.hasOwnProperty(property)) {
                uniqueValuesSet.add(obj[property]);
            }
        });
    });
    // Convert the Set to an array
    const uniqueValuesArray = Array.from(uniqueValuesSet);
    return uniqueValuesArray;
}

//Return the the totals 
const calculateTotals = (arr) => {
    const obj = {};
    for (let i=0; i < arr.length; i++){
        for (let j=0; j < Object.keys(arr[i]).length; j++){
            if(Object.keys(obj).includes(Object.keys(arr[i])[j])){
                obj[Object.keys(arr[i])[j]] = obj[Object.keys(arr[i])[j]] + Number(Object.values(arr[i])[j])
            } else {
                obj[Object.keys(arr[i])[j]] = Number(Object.values(arr[i])[j])
            }
        }
    }
    delete obj.date
    return obj;
}

//Returns top 9 values
const calculateTopTen = (arr) => {
    const totals = sortObjByValues(calculateTotals(arr));
    if(totals.length <= 10) {return totals}
    const topNine = totals.slice(0, 9);
    return [...topNine]
}

//Calculate the totals after removing top values
const filterByTopValues = (arr, topKeys, indicator) => {
    const filteredArr = [];
    const cuttedListIndicators = ['ctr', 'cpm', 'fillRate', 'viewability'];
    for(let i=0; i<arr.length; i++){
        const otherValues = [];
        const filteredObj = {...arr[i]};
        const currentKeys = Object.keys(arr[i]);
        const diff = getDiffBetweenArrays(currentKeys, topKeys);
        for(let j=0; j<currentKeys.length; j++){
            if(diff.includes(currentKeys[j]) && currentKeys[j] !== 'date'){
                otherValues.push(filteredObj[currentKeys[j]]);
                delete filteredObj[currentKeys[j]];
            }
        }
        const sumOfOthers = otherValues.length ? CalculusUtils.simpleReducer(otherValues) : 0;
        const othersValue = cuttedListIndicators.includes(indicator) ? 0 : Number(sumOfOthers) || 0;
        filteredArr.push({...filteredObj, Others: othersValue.toFixed(2)})
    }
    return filteredArr;
}

//Build initial set of value for the chart
const buildInitialArray = (dimension, values) => values.map((i) => ({[dimension]: i, revenue: 0, cpm: 0, impressions: 0, adsRequests: 0, ctr: 0, fillRate: 0}));

//Build final set of values, by adding the grouped data into the initial set
// const buildFinalArray = (initialMappedData, groupedData, dimension) => {
//     const finalData = {...initialMappedData};
//     const groupedDataKeys = Object.keys(groupedData);
//     groupedDataKeys.forEach((key) => {
//         const initialSet = [...initialMappedData[key]];
//         if(initialSet.length === groupedData[key].length){
//             finalData[key] = groupedData[key]
//         } else{
//             let temp = [...finalData[key]];
//             const groupedDimensionKeys = [];
//             groupedData[key].forEach((groupedKey) => groupedDimensionKeys.push(groupedKey[dimension]));
//             groupedDimensionKeys.forEach((groupedDimensionKey) => {
//                 for(let i=0; i<temp.length; i++){
//                     if(temp[i][dimension] === groupedDimensionKey){
//                         temp = temp.filter((tempKey) => tempKey[dimension] !== groupedDimensionKey)        
//                     }
//                 }
//             })
//             finalData[key] = [...groupedData[key], ...temp]
//         }

//     })
//     return finalData;
// }

const buildFinalArray = (initialMappedData, groupedData, dimension) => {
    const finalData = {...initialMappedData};
    const groupedDataKeys = Object.keys(groupedData);

    groupedDataKeys.forEach((key) => {
        const initialSet = Array.isArray(initialMappedData[key]) ? [...initialMappedData[key]] : [];
        const groupedSet = Array.isArray(groupedData[key]) ? groupedData[key] : [];

        if (initialSet.length === groupedSet.length) {
            finalData[key] = groupedSet;
        } else {
            let temp = Array.isArray(finalData[key]) ? [...finalData[key]] : [];
            const groupedDimensionKeys = [];

            groupedSet.forEach((groupedKey) => groupedDimensionKeys.push(groupedKey[dimension]));

            groupedDimensionKeys.forEach((groupedDimensionKey) => {
                temp = temp.filter((tempKey) => tempKey[dimension] !== groupedDimensionKey);
            });

            finalData[key] = [...groupedSet, ...temp];
        }
    });

    return finalData;
};


const chartPreparation = (fullData, dimension, indicator, period) => {
    //Group data by the date
    const groupedData = groupBy(fullData, 'date');
    //Get all the dates for the selected period in format ['YYYY-MM-DD']
    const dates = period.length === 22 && period.includes('to') ? getDatesByMacro['customRange'](period) : getDatesByMacro[period]();
    //Fill the missing grouped data
    const fullMappedGroupedData = {};
    const mappedData = buildInitialArray(
                            dimension, 
                            getUniquePropertyValues(
                                Object.values(groupedData), 
                                dimension
                            )
                        );
    dates.forEach((date) => fullMappedGroupedData[date] = [...mappedData]);
    //Get all the values for all the days in format [{date: 'YYYY-MM-DD', provider: 'AAA', ...}, {date: 'YYYY-MM-DD', provider: 'BBB', ...}]
    const values = Object.values(buildFinalArray(fullMappedGroupedData, groupedData, dimension))
    //Prepare formated array
    const formatedArray = [];
    for (let i=0; i < dates.length; i++){
        formatedArray.push({date: dates[i]})
        for (let j=0; j < values[i].length; j++){
            formatedArray[i] = {
                ...formatedArray[i], 
                [values[i][j][dimension]]: indicator !== 'impressions' ? (values[i][j][indicator]).toFixed(2) : values[i][j][indicator]
            }
        }
    }
    //Pick top ten values of the chart
    const topTen = calculateTopTen(formatedArray);
    const valuesOfTopTen = getValuesFromKeys(topTen);
    const filteredData = filterByTopValues(formatedArray, valuesOfTopTen, indicator);
    return {
        topValues: valuesOfTopTen.length >= 9 ? [...valuesOfTopTen, 'Others'] : valuesOfTopTen,
        data: filteredData
    };
}

const biaxialChartPreparation = (fullData, period) => {
    //Extract data
    const {current, reference} = fullData;
    //Get all the dates for the selected period in format ['YYYY-MM-DD']
    const dates = period.length === 22 && period.includes('to') 
                    ? PeriodDateUtils.getAllDates([
                        new Date(period.split('to')[0]).getTime(), 
                        new Date(period.split('to')[1]).getTime()
                    ]) 
                    : getDatesByMacro[period]();
    //Create time shifted date with period 
    const timeShiftedReference = reference.map(i => ({...i, date: PeriodDateUtils.getShiftedDate(i.date, period, dates.length)}));
    //Group data by the date
    const groupedCurrentData = groupBy(current, 'date');
    const groupedReferenceData = groupBy(timeShiftedReference, 'date');
    //Prepare formated array
    const formatedArray = [];
    for (let i=0; i < dates.length; i++){
        formatedArray.push({
            date: dates[i], 
            impressionsCurrent: groupedCurrentData[dates[i]] ? groupedCurrentData[dates[i]][0].impressions : 0, 
            revenueCurrent: groupedCurrentData[dates[i]] ? (groupedCurrentData[dates[i]][0].revenue).toFixed(2) : 0, 
            cpmCurrent: groupedCurrentData[dates[i]] ? groupedCurrentData[dates[i]][0].cpm : 0,
            impressionsReference: groupedReferenceData[dates[i]] ? groupedReferenceData[dates[i]][0].impressions : 0, 
            revenueReference: groupedReferenceData[dates[i]] ? (groupedReferenceData[dates[i]][0].revenue).toFixed(2) : 0, 
            cpmReference: groupedReferenceData[dates[i]] ? groupedReferenceData[dates[i]][0].cpm : 0
        })
    }
    return formatedArray;            
}

//Prepare the data from backend in order to adapt for the charts
const tablePreparation  = (fullData, dimension) => {
    const formatedArray = [];
    if(!dimension){
        //when no dimension selected
        const revenue = CalculusUtils.sumObjectProps(fullData, 'revenue');
        const impressions = CalculusUtils.sumObjectProps(fullData, 'impressions');
        //const adsRequests = CalculusUtils.sumObjectProps(fullData, 'adsRequests');
        const clicks = CalculusUtils.sumObjectProps(fullData, 'clicks');
        formatedArray.push({
            key: 1,
            dimension: 'Total',
            revenue,
            impressions,
            cpm: revenue && impressions ? ((revenue/impressions) * 1000).toFixed(2) : 0,
            //fillRate: impressions && adsRequests ? ((impressions/adsRequests) * 100).toFixed(2) : 0,
            ctr: impressions && clicks ? ((clicks/impressions) * 100).toFixed(2) : 0,
            revenueShare: '100%',
            revenueChart: []
        });
    } else {
        const groupedData = groupBy(fullData, dimension);
        const keys = Object.keys(groupedData);
        const values = Object.values(groupedData);
        const totalRevenue = CalculusUtils.sumObjectProps(fullData, 'revenue');
        for(let i=0; i < keys.length; i++){
            const revenue = CalculusUtils.sumObjectProps(values[i], 'revenue');
            const impressions = CalculusUtils.sumObjectProps(values[i], 'impressions');
            //const adsRequests = CalculusUtils.sumObjectProps(values[i], 'adsRequests');
            const clicks = CalculusUtils.sumObjectProps(values[i], 'clicks');
            formatedArray.push({
                key: i+1,
                dimension: keys[i],
                revenue: revenue.toFixed(2),
                impressions: impressions,
                cpm: revenue && impressions ? ((revenue/impressions) * 1000).toFixed(2) : 0,
                //fillRate: impressions && adsRequests ? ((impressions/adsRequests) * 100).toFixed(2) : 0,
                ctr: impressions && clicks ? ((clicks/impressions) * 100).toFixed(2) : 0,
                revenueChart: values[i],
                revenueShare: revenue && totalRevenue ? ((revenue/totalRevenue) * 100).toFixed(2) : 0,
            })
        }
    }
    return formatedArray;
}

export {
    chartPreparation,
    biaxialChartPreparation,
    tablePreparation,
    groupBy
}